import script from "./ReserveActionsButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReserveActionsButton.vue?vue&type=script&setup=true&lang=ts"

import "./ReserveActionsButton.vue?vue&type=style&index=0&id=5947d8aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5947d8aa"]])

export default __exports__